import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Header from '../components/Header';
import './index.css';
import ReactGA from 'react-ga';
import icon32 from '../assets/dbLogo.png';
ReactGA.initialize('UA-29961590-1');


const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title='DBeerman - Full Stack Developer // Software Engineer'
      meta={[
        { name: 'description', content: 'Dans Portfolio Site' },
        {
          name: 'keywords',
          content: 'porfolio, developer, engineer, software, code',
        },
      ]}
      link={
        [
          { rel: 'shortcut icon', type: 'image/png', href: `${icon32}` }
        ]}
    />
    <Header />
    {children()}
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper;


// WEBPACK FOOTER //
// ./src/layouts/index.js